import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const BreadcrumbStyle = ({ theme }) => ({
  margin: '15px auto 12px auto',
  [theme.breakpoints.up('md')]: {
    marginBottom: '24px',
    marginTop: '10px'
  }
});

export const BreadcrumbWrapStyled = styled(Box)(BreadcrumbStyle);
